import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Message, List, Flag } from 'nallian-shared-ui/lib/components';
import Responsive from 'nallian-shared-ui/lib/components/Responsive/Responsive';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';
import CountryName from '../../app/components/CountryName';

const SplitList = styled(props => <List {...props} />)`
  &.ui.list .item {
    break-inside: avoid-column;
    page-break-inside: avoid;
    -webkit-column-break-inside: avoid;
    padding: 0.5rem;
    border-radius: 0.25rem;
    transition: 0.2s background-color;
    text-shadow: #fff 0 0 1px;
  }
  @media screen and (min-width: ${Responsive.onlyTablet.minWidth}px) {
    column-count: 2;
  }
`;

const ExistingVehicleMessage = ({ vehicle, t }) => (
  <Fragment>
    <Message info>
      <Message.Header>{t('vehicleAlreadyExists')}</Message.Header>
      <p>{t('addVehicleToPrivateList')}</p>
    </Message>
    <SplitList>
      <List.Item header={t('type')} content={get(vehicle, 'type', '...')} />
      <List.Item
        header={t('country')}
        content={
          vehicle && vehicle.countryCode ? (
            <Fragment>
              <Flag name={vehicle.countryCode.toLowerCase()} />{' '}
              <CountryName code={vehicle.countryCode} />
            </Fragment>
          ) : (
            '...'
          )
        }
      />
      <List.Item header={t('createdBy')} content={vehicle ? vehicle.createdBy : '...'} />
      <List.Item header={t('owner')} content={get(vehicle, 'owner', '...')} />
    </SplitList>
  </Fragment>
);

ExistingVehicleMessage.propTypes = { vehicle: PropTypes.object, t: PropTypes.func.isRequired };
ExistingVehicleMessage.defaultProps = { vehicle: undefined };

export default withTranslation()(ExistingVehicleMessage);
